import React from 'react';

import ICO_HEART from 'assets/images/ico-heart.svg';

const FrequentlyBtnComponent = (props) => (
  <div className="frequently-btn" onClick={props.onClickFrequentBtn} role="menuitem" tabIndex={0}>
    <img src={ICO_HEART} alt="Frequently booked services" />

    <span className="item-name f-b">Frequently Booked Services</span>
  </div>
);
export default FrequentlyBtnComponent;
